import { Suspense, useMemo } from 'react'
import { Canvas } from '@react-three/fiber'
import { Center, OrbitControls, useGLTF } from '@react-three/drei'

const ProductModel = ({url}: {url: string}) => {
    const {scene} = useGLTF(url)
    const model = useMemo(() => scene.clone(true), [scene])
    return <Center><primitive object={model} scale={20} dispose={null} /></Center>
}

export const ModelPreview = ({url, active}: {url: string; active: boolean}) => (
    <Canvas frameloop={active ? 'always' : 'never'} camera={{position: [2, 1.2, 4], fov: 35}}>
        <ambientLight intensity={0.8} />
        <directionalLight position={[-3, 4, 5]} intensity={2} />
        <directionalLight position={[4, 2, -3]} intensity={2} />
        <Suspense fallback={null}>
            <ProductModel url={url} />
        </Suspense>
        <OrbitControls enableZoom={false} enablePan={false} />
    </Canvas>
)
